import React from 'react';
import Icon from '@atlaskit/icon';
import {ReactComponent as LadaLogo} from '../images/logo.svg';
import {ReactComponent as SystemImg} from '../images/system.svg';
import {ReactComponent as CarImg} from '../images/car.svg';
import {ReactComponent as AndroidImg} from '../images/android-brands.svg';
import {ReactComponent as AppleImg} from '../images/apple-brands.svg';
import {ReactComponent as DiagnosticImg} from '../images/diagnostic.svg';

import {colors} from '@atlaskit/theme';

export const LadaLogoIcon = ({primaryColor}) => (
  <Icon glyph={LadaLogo} label='LADA logo' primaryColor={primaryColor ? primaryColor : colors.B50} />
);

export const SystemIcon = () => (
  <Icon glyph={SystemImg} label='system' />
);

export const CarIcon = () => (
  <Icon glyph={CarImg} label='car' />
);

export const AppleIcon = () => (
  <Icon glyph={AppleImg} label='apple' />
);

export const AndroidIcon = () => (
  <Icon glyph={AndroidImg} label='android' />
);

export const DiagnosticIcon = () => (
  <Icon glyph={DiagnosticImg} label='Diagnostic' />
);